import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStars = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 124,
	height: 25,
	viewBox: "0 0 124 25",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 24.6632,
			height: 24.6632,
			fill: "#04C473"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 24.6641,
			width: 24.6632,
			height: 24.6632,
			fill: "#04C473"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 49.3203,
			width: 24.6632,
			height: 24.6632,
			fill: "#04C473"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 73.9844,
			width: 24.6632,
			height: 24.6632,
			fill: "#04C473"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 98.6484,
			width: 24.6632,
			height: 24.6632,
			fill: "#04C473"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0904 1.95503C12.1643 1.7278 12.4857 1.7278 12.5596 1.95503L14.7614 8.73154C14.7944 8.83316 14.8891 8.90196 14.9959 8.90196H22.1212C22.3601 8.90196 22.4594 9.20769 22.2662 9.34812L16.5017 13.5362C16.4153 13.599 16.3791 13.7104 16.4121 13.812L18.6139 20.5885C18.6878 20.8157 18.4277 21.0047 18.2344 20.8642L12.47 16.6761C12.3835 16.6133 12.2665 16.6133 12.18 16.6761L6.41559 20.8642C6.2223 21.0047 5.96223 20.8157 6.03606 20.5885L8.23789 13.812C8.2709 13.7104 8.23473 13.599 8.14829 13.5362L2.38385 9.34812C2.19056 9.20769 2.2899 8.90196 2.52881 8.90196H9.65406C9.76091 8.90196 9.8556 8.83316 9.88862 8.73154L12.0904 1.95503Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.7545 1.95503C36.8283 1.7278 37.1498 1.7278 37.2236 1.95503L39.4254 8.73154C39.4585 8.83316 39.5532 8.90196 39.66 8.90196H46.7853C47.0242 8.90196 47.1235 9.20769 46.9302 9.34812L41.1658 13.5362C41.0793 13.599 41.0432 13.7104 41.0762 13.812L43.278 20.5885C43.3518 20.8157 43.0918 21.0047 42.8985 20.8642L37.134 16.6761C37.0476 16.6133 36.9305 16.6133 36.8441 16.6761L31.0797 20.8642C30.8864 21.0047 30.6263 20.8157 30.7001 20.5885L32.9019 13.812C32.935 13.7104 32.8988 13.599 32.8124 13.5362L27.0479 9.34812C26.8546 9.20769 26.954 8.90196 27.1929 8.90196H34.3181C34.425 8.90196 34.5197 8.83316 34.5527 8.73154L36.7545 1.95503Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.4264 1.95503C61.5002 1.7278 61.8217 1.7278 61.8955 1.95503L64.0973 8.73154C64.1303 8.83316 64.225 8.90196 64.3319 8.90196H71.4571C71.696 8.90196 71.7954 9.20769 71.6021 9.34812L65.8376 13.5362C65.7512 13.599 65.715 13.7104 65.7481 13.812L67.9499 20.5885C68.0237 20.8157 67.7636 21.0047 67.5704 20.8642L61.8059 16.6761C61.7195 16.6133 61.6024 16.6133 61.516 16.6761L55.7515 20.8642C55.5582 21.0047 55.2982 20.8157 55.372 20.5885L57.5738 13.812C57.6068 13.7104 57.5707 13.599 57.4842 13.5362L51.7198 9.34812C51.5265 9.20769 51.6258 8.90196 51.8648 8.90196H58.99C59.0968 8.90196 59.1915 8.83316 59.2246 8.73154L61.4264 1.95503Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.0904 1.95503C86.1643 1.7278 86.4857 1.7278 86.5596 1.95503L88.7614 8.73154C88.7944 8.83316 88.8891 8.90196 88.9959 8.90196H96.1212C96.3601 8.90196 96.4594 9.20769 96.2662 9.34812L90.5017 13.5362C90.4153 13.599 90.3791 13.7104 90.4121 13.812L92.6139 20.5885C92.6878 20.8157 92.4277 21.0047 92.2344 20.8642L86.47 16.6761C86.3835 16.6133 86.2665 16.6133 86.18 16.6761L80.4156 20.8642C80.2223 21.0047 79.9622 20.8157 80.0361 20.5885L82.2379 13.812C82.2709 13.7104 82.2347 13.599 82.1483 13.5362L76.3838 9.34812C76.1906 9.20769 76.2899 8.90196 76.5288 8.90196H83.6541C83.7609 8.90196 83.8556 8.83316 83.8886 8.73154L86.0904 1.95503Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.755 1.95503C110.828 1.7278 111.15 1.7278 111.224 1.95503L113.425 8.73154C113.458 8.83316 113.553 8.90196 113.66 8.90196H120.785C121.024 8.90196 121.124 9.20769 120.93 9.34812L115.166 13.5362C115.079 13.599 115.043 13.7104 115.076 13.812L117.278 20.5885C117.352 20.8157 117.092 21.0047 116.898 20.8642L111.134 16.6761C111.048 16.6133 110.931 16.6133 110.844 16.6761L105.08 20.8642C104.886 21.0047 104.626 20.8157 104.7 20.5885L106.902 13.812C106.935 13.7104 106.899 13.599 106.812 13.5362L101.048 9.34812C100.855 9.20769 100.954 8.90196 101.193 8.90196H108.318C108.425 8.90196 108.52 8.83316 108.553 8.73154L110.755 1.95503Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 24.9107,
			y1: 1.07807e-8,
			x2: 24.9107,
			y2: 24.6632,
			stroke: "white",
			strokeWidth: .493264
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 49.5669,
			y1: 1.07807e-8,
			x2: 49.5669,
			y2: 24.6632,
			stroke: "white",
			strokeWidth: .493264
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 74.231,
			y1: 1.07807e-8,
			x2: 74.231,
			y2: 24.6632,
			stroke: "white",
			strokeWidth: .493264
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 98.8951,
			y1: 1.07807e-8,
			x2: 98.8951,
			y2: 24.6632,
			stroke: "white",
			strokeWidth: .493264
		})
	]
});
export default SvgStars;
